import { FacebookConnectorIcon, FacebookWhiteConnectorIcon } from '@/assets';
import { AccountSelection } from '../AccountSelection/AccountSelection';
import { FACEBOOK_CONNECTION_STEPS } from '@/utils/constants';

export const FBEditConnector = () => {
  return (
    <AccountSelection
      title="Facebook"
      connectionSteps={FACEBOOK_CONNECTION_STEPS}
      selectedIcon={FacebookWhiteConnectorIcon}
      unselectedIcon={FacebookConnectorIcon}
    />
  );
};
